module.exports = __webpack_public_path__ + "img/packshots-mobile.0531bcbc.png";